<template>
  <div>
    <v-expansion-panels v-model="slot_panel">
      <v-expansion-panel>
        <v-expansion-panel-header class="px-4 py-2" style="min-height: 48px">
          <h3 class="my-0 subtitle-1 font-weight-bold text-center">
            รายการคาบเรียนทั้งหมด
            <span class="blue--text">: {{ totalTime }}</span>
          </h3>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-simple-table dense class="mb-5">
            <template v-slot:default>
              <tbody>
                <tr
                  v-for="(item, index) in sorted_all_time_slot"
                  :key="item.start_date_time.unix()"
                >
                  <td>{{ index + 1 }}.</td>
                  <td>
                    {{
                      item.start_date_time.locale("th").format("dddd D MMMM")
                    }}
                    {{ item.start_date_time.year() + 543 }}
                  </td>
                  <td>เวลา</td>
                  <td>{{ item.start_date_time.format("HH:mm") }}</td>
                  <td>ถึง</td>
                  <td>{{ item.end_date_time.format("HH:mm") }}</td>
                  <td>
                    <v-btn
                      small
                      icon
                      color="red"
                      @click="remove_time_slot(index)"
                    >
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <v-tabs v-model="adding_tab" class="mt-4" background-color="transparent">
      <v-tabs-slider color="deep-orange"></v-tabs-slider>
      <v-tab><h3>กำหนดวัน-เวลาเรียน แบบปกติ</h3></v-tab>
      <v-tab><h3>กำหนดวัน-เวลาเรียน แบบ ด้วยตนเอง</h3></v-tab>
    </v-tabs>

    <v-tabs-items v-model="adding_tab">
      <v-tab-item>
        <TimeSlotPresetAdding
          :level-id="levelId"
          :current_time_slots="all_time_slot"
          :add_new_time_slot="(data) => add_new_time_slot(data)"
          :delete_all_slot="delete_all_slot"
        />
      </v-tab-item>
      <v-tab-item>
        <TimeSlotAdding
          :current_time_slots="all_time_slot"
          :add_new_time_slot="(data) => add_new_time_slot(data)"
        />
      </v-tab-item>
    </v-tabs-items>

    <!-- Add Set -->
  </div>
</template>

<script>
import TimeSlotAdding from "./TimeSlotAdding.vue";
import TimeSlotPresetAdding from "./TimeSlotPresetAdding.vue";
import ConfigTeachTableProvider from "@/services/config_teach_table.provider.js";
import * as dayjs from "dayjs";
const ConfigTeachTableService = new ConfigTeachTableProvider();

require("dayjs/locale/th");
export default {
  name: "TimeSlot",
  props: {
    levelId: {
      type: [String, Number],
      default: 1,
    },
  },
  data: () => ({
    all_time_slot: [],
    temp_time_slot: [],
    adding_tab: null,
    slot_panel: 0,
    totalTime: "-",
  }),
  computed: {
    sorted_all_time_slot() {
      let all_time_slot = this.all_time_slot;
      return all_time_slot.sort(function(a, b) {
        return a.start_date_time.unix() - b.start_date_time.unix();
      });
    },
  },
  components: {
    TimeSlotAdding,
    TimeSlotPresetAdding,
  },
  methods: {
    delete_all_slot() {
      this.temp_time_slot = this.all_time_slot;
      this.all_time_slot = [];
      this.totalTime = "-";
    },
    add_new_time_slot(new_time_slot) {
      this.all_time_slot = [...this.all_time_slot, ...new_time_slot];
      this.calculate_time();
    },
    remove_time_slot(index) {
      this.all_time_slot.splice(index, 1);
      this.calculate_time();
    },
    async save_to_db(level_id, teach_table_id) {
      const ret = this.all_time_slot.map((item) => ({
        ...item,
        start_date_time: item.start_date_time.format("YYYY-MM-DD HH:mm:ss"),
        end_date_time: item.end_date_time.format("YYYY-MM-DD HH:mm:ss"),
      }));
      const response = await ConfigTeachTableService.setTimeSlot({
        level_id,
        teach_table_id,
        all_time_slot: ret,
      }).catch((error) => {
        this.$toasted.error(JSON.stringify(error.response.data.message), {
          duration: 0,
        });
        return null;
      });

      if (response && response.status) {
        this.$toasted.success(
          this.$t("config_teach_table.save_time_slot_successfully"),
          {
            duration: 0,
          }
        );
        return true;
      }
      return false;
    },
    async get_time_slot(level_id, teach_table_id) {
      const data = await ConfigTeachTableService.getTimeSlot({
        level_id,
        teach_table_id,
      });
      this.all_time_slot = data.all_time_slot.map((item) => ({
        ...item,
        start_date_time: dayjs(item.START_DATE_TIME, "YYYY-MM-DD HH:mm:ss"),
        end_date_time: dayjs(item.END_DATE_TIME, "YYYY-MM-DD HH:mm:ss"),
      }));
      this.calculate_time();
    },
    async calculate_time() {
      let diffSum = 0;
      for (const item in this.all_time_slot) {
        let time_slot = this.all_time_slot[item];
        let now = dayjs(time_slot.start_date_time, "HH:mm:ss");
        let then = dayjs(time_slot.end_date_time, "HH:mm:ss");
        diffSum += then.diff(now);
      }
      let ms = diffSum % 1000;
      diffSum = (diffSum - ms) / 1000;
      let secs = diffSum % 60;
      diffSum = (diffSum - secs) / 60;
      let mins = diffSum % 60;
      let hrs = (diffSum - mins) / 60;
      this.totalTime = hrs + " ชั่วโมง " + mins + " นาที ";
    },
  },
};
</script>
